import React, { useState } from 'react';
import { Layout, Typography, Table, Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { isValidArray } from '../../../utils/utilities';

const { Header } = Layout;
const { Title, Text } = Typography;

const getColumnSearchProps = (dataIndex) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Search
        </Button>
        <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </Space>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
      : '',
});

const columns = [
  {
    title: 'Operator name',
    dataIndex: 'name',
    ...getColumnSearchProps('name'),
  },
  {
    title:'Owner name',
    dataIndex:'owner_name',
  },
  {
    title: 'Operator code',
    dataIndex: 'operator_code',
    ...getColumnSearchProps('operator_code'),
  },
  {
    title: 'Contact email',
    dataIndex: 'contact_email',
    ...getColumnSearchProps('contact_email'),
  },
  {
    title: 'Phone number',
    dataIndex: 'phone_number',
    ...getColumnSearchProps('phone_number'),
  }
];

export const BusOperatorsTable = props => {

  const { dataSource , updateformData , selectedData , loading}={...props};

  return (
      <div>
            <Table dataSource={!isValidArray(dataSource)?[]:dataSource}
                    pagination={{ pageSize: 5 }}
                   columns={columns}
                   rowClassName={ (record, index) => {return record.id== selectedData.id?"TableRowClicked":""}   }
                   loading={loading}
                   rowKey={record => record.id}
                   onRow={(record, rowIndex) => {
                      return {
                        onClick: event => {
                          updateformData(record);
                        }, // click row
                        onDoubleClick: event => {

                        }, // double click row
                        onContextMenu: event => {

                        }, // right button click row
                        onMouseEnter: event => {

                        }, // mouse enter row
                        onMouseLeave: event => {

                        }, // mouse leave row
                      };
                    }}
                   />
      </div>
  );
};
